import { render } from "./EditarMatriculaDialog.vue?vue&type=template&id=099fcfa3"
import script from "./EditarMatriculaDialog.vue?vue&type=script&lang=js"
export * from "./EditarMatriculaDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__